module.exports = "<div class=\"circle-container\">\n\t<div class=\"career-item\" ng-style=\"{ width: vm.getWidth() + '%' }\">\n\t  <div class=\"bubble-container\" ng-show=\"vm.calculateMatch() >= 50\">\n\t    <span class=\"career-match\" ng-bind=\"vm.calculateMatch() + '%'\"></span>\n\t  </div>\n\t  <div class=\"career-popover\" ng-style=\"{ left: vm.getPopoverLeft() + 'px' }\">\n\t    <span class=\"career-rate\" ng-bind=\"::vm.item.salary\"></span>\n\t    <a class=\"career-title\" ng-href=\"{{::vm.item.url}}\" ng-bind=\"::vm.item.name\"></a>\n\t  </div>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/careerCircle/careerCircle.html
// module id = 108
// module chunks = 0 1